import React, { memo, useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import useColors from 'hooks/useColors';
import Text from './Text';
import CircularProgress from './CircularProgress';
const BuySellHoldViewCircularProgress = ({ large, buyPercent, holdPercent, sellPercent }) => {
    const colors = useColors();
    const circularProgressInfo = useMemo(() => {
        if (buyPercent === undefined ||
            sellPercent === undefined ||
            holdPercent === undefined) {
            return {
                percent: 0,
                action: 'N/A',
                color: 'transparent',
            };
        }
        let progressInfo = {
            percent: buyPercent,
            action: 'Buy',
            color: colors.status.positive,
        };
        if (holdPercent > progressInfo.percent) {
            progressInfo = {
                percent: holdPercent,
                action: 'Hold',
                color: colors.text.tertiary,
            };
        }
        if (sellPercent > progressInfo.percent) {
            progressInfo = {
                percent: sellPercent,
                action: 'Sell',
                color: colors.elements.statusNegative,
            };
        }
        return progressInfo;
    }, [
        buyPercent,
        colors.elements.statusNegative,
        colors.status.positive,
        colors.text.tertiary,
        holdPercent,
        sellPercent,
    ]);
    return (<View style={styles.graphicsContainer}>
        <CircularProgress large={large} size={large ? 190 : 100} percent={circularProgressInfo.percent} backgroundCircleColor={colors.background.dark} progressCircleColor={circularProgressInfo.color}>
          <View style={styles.recommendedActionContainer}>
            {circularProgressInfo.percent ? (<>
                <Text {...(large ? { 'Numbers-24': true } : { 'Numbers-16': true })}>
                  {circularProgressInfo.percent}%
                </Text>
                <Text Secondary {...(large
            ? { 'TextThin-14': true }
            : { 'TextThin-12': true })}>
                  {circularProgressInfo.action}
                </Text>
              </>) : (<Text Text-24>N/A</Text>)}
          </View>
        </CircularProgress>
      </View>);
};
export default memo(BuySellHoldViewCircularProgress);
const styles = StyleSheet.create({
    graphicsContainer: {
        flexDirection: 'row',
    },
    recommendedActionContainer: {
        alignItems: 'center',
        justifyContent: 'center',
    },
});
